import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AllContents, AllContentsState } from '../../types/allContentTypes'
import { fetchAllContent } from '../../api/allContentApi'

const API_URL = process.env.REACT_APP_API_URL

export interface FetchAllContentResponse {
  success: boolean
  allContents?: {}
  message?: string
}

const initialState: AllContentsState = {
  allContents: {},
  currentContent: null,
  currentIndex: null,
  isLoading: false,
  error: null,
  currentPage: 1,
  playBackText: null,
  isPlaying: null,
}

export const fetchAllContentThunk = createAsyncThunk(
  'allcontents/fetchAllContent',
  async (_, thunkAPI) => {
    try {
      const response = await fetchAllContent()
      if (response.success) {
        return response.allContents
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const allContentSlice = createSlice({
  name: 'allContents',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllContentThunk.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchAllContentThunk.fulfilled, (state, action: any) => {
        state.allContents = action.payload ?? []
        state.isLoading = false
      })
      .addCase(fetchAllContentThunk.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message ?? 'Failed to load content'
      })
  },
})

export default allContentSlice.reducer
